import { motion } from "framer-motion";
import { Star, ArrowUpRight } from "lucide-react";
import { track } from "@/track";
import { useLang } from "@/i18n";

export default function Testimonials() {
  const { t } = useLang();

  return (
    <section id="testimonials" className="py-24 lg:py-32" data-testid="testimonials-section">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="overline-label" data-testid="testimonials-overline">{t("t_over")}</p>
          <h2 className="mt-5 font-serif font-semibold text-4xl sm:text-5xl tracking-tight leading-tight" data-testid="reviews-heading">
            {t("rev_h1")} <span className="text-brand-300">{t("rev_h2")}</span>
          </h2>
          <p className="mt-6 text-base text-cream/55 leading-relaxed max-w-xl mx-auto" data-testid="reviews-subcopy">
            {t("rev_sub")}
          </p>
          <a
            href="https://g.page/r/CVxTDGC9tF0kEAI/review"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="leave-review-btn"
            onClick={() => track("review_click")}
            className="group mt-10 inline-flex items-center gap-3 bg-brand text-white font-bold text-xs uppercase tracking-[0.2em] px-8 py-4 hover:bg-brand-600 transition-colors duration-300"
          >
            <Star size={15} /> {t("t_btn")}
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
